export const CACHE_KEYS = {
  all: ['procurement-new'] as const,
  projects: (filters: unknown) => [...CACHE_KEYS.all, 'projects', filters] as const,
  sortingOptions: () => [...CACHE_KEYS.all, 'sortingOptions'] as const,
} as const;
